import * as actionsTypes from './actionsTypes';

export const toggleNav = () => ({
  type: actionsTypes.NAV_TOGGLE,
});
